<div *ngIf="farm" style="padding-bottom: 300px;"> 
  <div *ngIf="subscribers">
    <h4 class="subs-count">Število naročnikov: {{ subscribers.count }}</h4>
    <div class="subscribers-container d-flex flex-wrap justify-content-start">
      <div class="card p-2 m-2" *ngFor="let subscriber of subscribers.subscribers">
        <div class="d-flex align-items-center">
          <fa-icon class="me-2 mb-0" [icon]="faUser"></fa-icon>
          <h3 class="fs-5 me-3 mb-1">{{ subscriber.username }}</h3>
          <p class="mb-2"> {{ subscriber.email }}</p>
          <button class="btn btn-danger ms-3" (click)="deleteSubscriber(subscriber)"><fa-icon class="mb-0" [icon]="faTrash"></fa-icon></button>
        </div>
        
      </div>
    </div>
  </div>
  
  
  <div *ngIf="allMessages">
    <h4 class="subs-count">Število vseh sporočil: {{ allMessages.count }}</h4>
    <div class="messages-container d-flex flex-wrap justify-content-start">
      <div class="card p-2 m-2" *ngFor="let message of allMessages.messages">
        <div class="d-flex align-items-center">
          <fa-icon class="me-2 mb-0" [icon]="faEnvelope"></fa-icon>
          <h6 class="me-3 mb-0">{{ message.sender }}</h6>
          <p class="mb-2 me-3"><strong> {{ message.subject }}</strong></p>
          <p class="card-text mb-2 me-3">{{ message.timestamp | date: 'dd.MM.yyyy' }}</p>
          <button class="btn btn-primary me-3" (click)="openMessageDetails(message)"><fa-icon class="mb-0 me-2" [icon]="faCircleInfo"></fa-icon>Podrobnosti</button>
          <button class="btn btn-danger" (click)="deleteMessage(message)"><fa-icon class="mb-0" [icon]="faTrash"></fa-icon></button>
        </div>
      </div>
    </div>
  </div>
</div>